import React from 'react';

const AboutPage: React.FC = () => {
  return (
    <>
      <h2 className='text-lg font-semibold mb-4'>About Page</h2>
    </>
  );
};

export default AboutPage;
